import "../src/dist/styles.css";
import Receipt from "./Pages/Receipt";
import Home from "./Pages/Home";
import { Route, Routes, useNavigate } from "react-router-dom";
import Models from "./Pages/Models";
import Upload from "./Pages/Upload";
import Reservation from "./Pages/Reservation";
import Panel from "./Pages/Panel";
import { useEffect, useState } from "react";
import md5 from 'md5';

const RequireAuth = ({ children }) => {
  const navigate = useNavigate();
  const [isVerified, setIsVerified] = useState(false);

  useEffect(() => {
    const token = sessionStorage.getItem('token');
    const processValue = sessionStorage.getItem('process');
    const hashedProcess = md5(processValue || '');

    // Check if token matches the hash of 'process'
    if (token !== hashedProcess) {
      navigate('/', { replace: true });
    } else {
      setIsVerified(true);
    }
  }, [navigate]);

  return isVerified ? children : null;
};

function App() {
  return (
    <>
      <Routes>
        <Route index path="/" element={<Home />} />
        <Route path="receipt" element={<Receipt />} />
        <Route path="models" element={<Models />} />
        <Route path="upload" element={<Upload />} />
        <Route path="reservation" element={<Reservation />} />
        <Route path="panel" element={<RequireAuth >
    <Panel />
  </RequireAuth >} />
      </Routes>
    </>
  );
}

export default App;
